import { Accordion, Code } from "@mantine/core"
import { MarkdownContent } from "atlas_forecasting_app/components/common/markdown_content"
import { ContributingForecastsSection } from "atlas_forecasting_app/components/forecast/contributing_forecasts_section"

export function ForecastMainDetails({ writeUp, calculationCode, question, contributingForecasts }) {
  const hasContributingForecasts = Array.isArray(contributingForecasts) && contributingForecasts.some((forecast) => forecast?.status === "completed")
  if (!writeUp && !calculationCode && !hasContributingForecasts) return null

  return (
    <Accordion variant="contained" radius="md" defaultValue={writeUp ? "write-up" : undefined}>
      {writeUp ? (
        <Accordion.Item value="write-up">
          <Accordion.Control>Write-up</Accordion.Control>
          <Accordion.Panel>
            <MarkdownContent source={writeUp} />
          </Accordion.Panel>
        </Accordion.Item>
      ) : null}
      {calculationCode ? (
        <Accordion.Item value="code">
          <Accordion.Control>Code</Accordion.Control>
          <Accordion.Panel>
            <pre className="af-code-block">
              <Code component="code" block={false}>
                {calculationCode}
              </Code>
            </pre>
          </Accordion.Panel>
        </Accordion.Item>
      ) : null}
      {hasContributingForecasts ? (
        <Accordion.Item value="contributing-forecasts">
          <Accordion.Control>Contributing forecasts</Accordion.Control>
          <Accordion.Panel>
            <ContributingForecastsSection question={question} forecasts={contributingForecasts} />
          </Accordion.Panel>
        </Accordion.Item>
      ) : null}
    </Accordion>
  )
}
